import * as React from "react"
import { useEffect, useContext } from "react"

// Components
import Image from "gatsby-image"
import { Section } from "../../StyledComponents/layoutComponentStyles"
import { $desktop } from "../../../utils/breakpoints"
import { useEmblaCarousel } from "embla-carousel/react"

import { Slide } from "../../../@types/global-types"

// Styles
import "./_const-carousel.scss"
import CursorContext from "../../../context/cursorContext"

interface EmblaConstraintCarouselProps {
  slides: Array<Slide>
}

/*









*/

const EmblaConstraintCarousel: React.FunctionComponent<EmblaConstraintCarouselProps> = ({ slides }) => {
  const { setCursorState } = useContext(CursorContext)

  const options = {
    dragFree: true,
    loop: $desktop ? false : true,
    speed: 0.1,
    inViewThreshold: 0.99,
  }
  const [EmblaCarouselReact, embla] = useEmblaCarousel(options)

  useEffect(() => {
    if (embla) {
      // Embla API is ready
    }
  }, [embla])

  return (
    <Section>
      <EmblaCarouselReact className='const-carousel__viewport'>
        <div
          className='const-carousel__container'
          onMouseEnter={() => setCursorState?.("is-drag")}
          onMouseDown={() => setCursorState?.("is-drag is-dragging")}
          onMouseUp={() => setCursorState?.("is-drag")}
          onMouseLeave={() => setCursorState?.("")}
          role='slider'
          aria-valuenow={0}
          tabIndex={0}
        >
          {slides.map((slide: any, index: number) => (
            <div className='const-carousel__slide' key={index}>
              <Image fluid={slide.image.asset.fluid} alt={slide.image.altText} draggable={false} className='const-carousel__img' />
            </div>
          ))}
        </div>
      </EmblaCarouselReact>
    </Section>
  )
}

export default EmblaConstraintCarousel
